import type { Client } from "openapi-fetch";

import type { paths } from "@eisox/core-api-client";

import type { ApiClientOptions, SafeRequest } from "../client";
import { createApiClient, createSafeRequest } from "../client";

/**
 * What every repository is built from. `client` sits next to `request` because some endpoints need
 * the raw call — non-JSON payloads (`parseAs`) or status-dependent fallbacks — and because an app
 * extends its transport through it (`api.client.use(...)`).
 */
export interface CoreApiClient {
  client: Client<paths>;
  request: SafeRequest<paths>;
}

export const createCoreApiClient = (options: ApiClientOptions): CoreApiClient => {
  const client = createApiClient<paths>(options);
  return { client, request: createSafeRequest(client) };
};
